import type { InvoiceDirection } from '@tandemone/types'
import { useQuery } from '@tanstack/react-query'

import { getInvoiceStats } from './api'
import { INVOICE_STATS_KEY } from './keys'

export function useInvoiceStats(direction: InvoiceDirection) {
  return useQuery({
    queryKey: [...INVOICE_STATS_KEY, direction],
    queryFn: ({ signal }) => getInvoiceStats(direction, signal)
  })
}
